/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface AbpPtwExceptionHttpResponseModelData
 */
export interface AbpPtwExceptionHttpResponseModelData {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof AbpPtwExceptionHttpResponseModelData
     */
    $type?: AbpPtwExceptionHttpResponseModelDataTypeEnum;
}


/**
 * @export
 */
export const AbpPtwExceptionHttpResponseModelDataTypeEnum = {
    SystemCollectionsIDictionarySystemPrivateCoreLib: 'System.Collections.IDictionary, System.Private.CoreLib'
} as const;
export type AbpPtwExceptionHttpResponseModelDataTypeEnum = typeof AbpPtwExceptionHttpResponseModelDataTypeEnum[keyof typeof AbpPtwExceptionHttpResponseModelDataTypeEnum];



/**
 * Check if a given object implements the AbpPtwExceptionHttpResponseModelData interface.
 */
export function instanceOfAbpPtwExceptionHttpResponseModelData(value?: unknown): value is AbpPtwExceptionHttpResponseModelData {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AbpPtwExceptionHttpResponseModelDataTypeEnum)[0];
}

export function AbpPtwExceptionHttpResponseModelDataFromJSON(json: any): AbpPtwExceptionHttpResponseModelData {
    return AbpPtwExceptionHttpResponseModelDataFromJSONTyped(json, false);
}

export function AbpPtwExceptionHttpResponseModelDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbpPtwExceptionHttpResponseModelData {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AbpPtwExceptionHttpResponseModelDataToJSON(value?: AbpPtwExceptionHttpResponseModelData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value['$type'],
    });
}

